<template>
  <div class="close-button">
    <a href="#" @click="onClick">✕</a>
  </div>
</template>

<script>
export default {
  name: "CloseModalButton",
  props: ['onClick'],
}
</script>

<style scoped>
.close-button {
  position: absolute;
  top: 1rem;
  right: 1rem;
}

.close-button a {
  font-size: 1.3rem;
  color: #000000;
}
</style>
